<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="container">
					<div class="form-floating mb-3">
						<input
							type="text"
							class="form-control"
							id="filters.search"
							name="filters.search"
							[(ngModel)]="filters.search"
						/>
						<label class="form-label" for="filters.search" for="filters.search">Wyszukiwarka</label>
					</div>
					<hr />
					<label for="category" class="mt-3">Kategoria wydarzenia</label>
					<ng-select
						id="category"
						name="category"
						[(ngModel)]="filters.category"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of categories" [value]="item.id">{{ item.name }}</ng-option>
					</ng-select>
					<div class="form-floating mt-3">
						<select
							class="form-select"
							id="is_virtual_driver"
							name="is_virtual_driver"
							[(ngModel)]="filters.is_virtual_driver"
						>
							<option value="">(wszystkie)</option>
							<option [value]="item.id" *ngFor="let item of yesno">
								{{ item.name }}
							</option>
						</select>
						<label for="is_virtual_driver">Wydarzenia z kierowcami wirtualnymi</label>
					</div>
					<label for="status" class="mt-3">Status</label>
					<ng-select
						id="status"
						name="status"
						[(ngModel)]="filters.status"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of statuses" [value]="item.id">{{ item.name }}</ng-option>
					</ng-select>
					<label for="vehicle_busType" class="mt-3">Typ pojazdu</label>
					<ng-select
						id="vehicle_busType"
						name="vehicle_busType"
						[(ngModel)]="filters.vehicle_busType"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of vehicle_busTypes" [value]="item.id">{{ item.name }}</ng-option>
					</ng-select>
					<label for="vehicle_status" class="mt-3">Status pojazdu</label>
					<ng-select
						id="vehicle_status"
						name="vehicle_status"
						[(ngModel)]="filters.vehicle_status"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of vehicle_statuses" [value]="item.id">{{ item.name }}</ng-option>
					</ng-select>
					<label class="form-label" class="mt-3" for="owner">Opiekun</label>
					<ng-select id="owner" name="owner" [(ngModel)]="filters.owners" bindLabel="name">
						<ng-option *ngFor="let item of users" [value]="item.id">{{ item.name }}</ng-option>
					</ng-select>
					<label class="form-label" class="mt-3" for="organizationOwner">Opiekun organizacji</label>
					<ng-select
						id="organizationOwner"
						name="organizationOwner"
						[(ngModel)]="filters.organizationOwner"
						bindLabel="name"
					>
						<ng-option *ngFor="let item of users" [value]="item.id">{{ item.name }}</ng-option>
					</ng-select>
					<div class="form-floating mt-3">
						<select
							class="form-select"
							id="driver_informed_departure"
							name="driver_informed_departure"
							[(ngModel)]="filters.driver_informed_departure"
						>
							<option value="">(brak)</option>
							<option [value]="item.id" *ngFor="let item of yesno">
								{{ item.name }}
							</option>
						</select>
						<label for="driver_informed_departure">Kierowcy poinformowani (wyjazd)</label>
					</div>
					<div class="form-floating mt-3">
						<select
							class="form-select"
							id="driver_informed_return"
							name="driver_informed_return"
							[(ngModel)]="filters.driver_informed_return"
						>
							<option value="">(brak)</option>
							<option [value]="item.id" *ngFor="let item of yesno">
								{{ item.name }}
							</option>
						</select>
						<label for="driver_informed_return">Kierowcy poinformowani (powrót)</label>
					</div>
					<div class="form-floating mt-3">
						<select
							class="form-select"
							id="guide_informed"
							name="guide_informed"
							[(ngModel)]="filters.guide_informed"
						>
							<option value="">(brak)</option>
							<option [value]="item.id" *ngFor="let item of yesno">
								{{ item.name }}
							</option>
						</select>
						<label for="guide_informed">Informowanie przewodnika</label>
					</div>
					<div class="form-floating mt-3">
						<select
							class="form-select"
							id="showDeleted"
							name="showDeleted"
							[(ngModel)]="filters.showDeleted"
						>
							<!-- <option value="">(brak)</option> -->
							<option [value]="item.id" *ngFor="let item of yesno">
								{{ item.name }}
							</option>
						</select>
						<label for="showDeleted">Pokaż usunięte wydarzenia</label>
					</div>
					<div class="form-floating mt-3">
						<select
							class="form-select"
							id="showSettled"
							name="showSettled"
							[(ngModel)]="filters.showSettled"
						>
							<option value="">(brak)</option>
							<option [value]="item.id" *ngFor="let item of yesno">
								{{ item.name }}
							</option>
						</select>
						<label for="showSettled">Zapłacone</label>
					</div>
					<div class="form-floating mt-3">
						<select
							class="form-select"
							id="haveOpinion"
							name="haveOpinion"
							[(ngModel)]="filters.haveOpinion"
						>
							<option value="">(brak)</option>
							<option [value]="item.id" *ngFor="let item of yesno">
								{{ item.name }}
							</option>
						</select>
						<label for="info">Zawiera opinię po wyjeździe</label>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="container">
					<div class="row">
						<div class="col-sm-7 text-start">
							<button type="button" class="btn btn-danger me-1" (click)="filtersClear()">Wyczyść</button>
							<button type="button" class="btn btn-success" (click)="filtersDefault()">Domyślne</button>
						</div>
						<div class="col-sm-5 text-end">
							<button type="button" class="btn btn-primary me-1" (click)="filtersSave()">Pokaż</button>
							<button
								type="button"
								class="btn btn-secondary"
								(click)="filtersClose()"
								data-bs-dismiss="modal"
							>
								Anuluj
							</button>
						</div>
					</div>
					<div class="row mt-2">
						<div class="col-sm-12 text-start"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
